import axios, { AxiosResponse } from 'axios'
import { WhiteLabelBrandSettingsInterface } from 'src/shared/types/brand-settings-interface'

export const getBrandSettings = (): Promise<
  AxiosResponse<WhiteLabelBrandSettingsInterface>
> => {
  return axios.get('/api/brand-settings')
}
